import { Button } from "@mui/material";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import Fields from "../Forms/UserSettings/SettingsFields";
import { helpHttp } from "../../helper/helpHttp";
import { useEffect, useState } from "react";
import { useUser } from "../../hooks/useUser";
import { updateUser } from "../../redux/slices/user";
import { useDispatch } from "react-redux";

const requiredFields = [
  "tipo_documento",
  "numero_documento",
  "nombres",
  "apellidos",
  "correo",
  "ruta",
  "departamento",
  "ciudad",
  "nombre_negocio",
];

export const UpdateUserModal = () => {
  const { get } = helpHttp();
  const { user } = useUser();
  const dispatch = useDispatch();

  const [showModal, setShowModal] = useState(false);
  const [userData, setUserData] = useState(null);
  const [loadedData, setLoadedData] = useState(false);

  useEffect(() => {
    if (userData) {
      requiredFields.forEach((field) => {
        if (!userData[field]) {
          setShowModal(true);
        }
      });
    }
  }, [userData]);

  useEffect(() => {
    if (!loadedData && user?.codigo_rol === "USUA") {
      get(`usuarios/getUsuarioById/${user.id}`).then((response) => {
        const datos = response?.datos;
        if (datos) {
          setUserData(datos);
          if (!loadedData) {
            dispatch(updateUser(datos));
            setLoadedData(true);
          }
        }
      });
    }
  }, [user]);

  const handleClose = () => {
    setShowModal(false);
  };

  return (
    <Dialog open={showModal} onClose={() => {}}>
      <DialogTitle>Actualiza tus datos</DialogTitle>
      <DialogContent>
        <DialogContentText>
          Antes de continuar, por favor ayúdanos a actualizar los siguientes
          datos:
        </DialogContentText>
        <Fields showClose={false} onSuccess={handleClose} />
      </DialogContent>
    </Dialog>
  );
};
